import Vue from "vue";
import Router from "vue-router";
import { getToken } from "@/utils/h5Plus";

//Dashboard 首页

Vue.use(Router);

export let routers = [
  {
    path: "/index",
    name: "index",
    component: () => import("@/pages/index.vue"),
    meta: {
      title: "首页"
    }
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/pages/login/login.vue")
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/pages/register/register.vue")
  },
  {
    path: "/takePicture",
    name: "takePicture",
    component: () => import("@/pages/register/takePicture.vue")
  },
  {
    path: "/idCard",
    name: "idCard",
    component: () => import("@/pages/register/idCard.vue")
  },
  {
    path: "/",
    name: "home",
    component: () => import("@/pages/home/home.vue") //首页
  },
  {
    path: "/permissions",
    name: "permissions",
    component: () => import("@/pages/home/permissions.vue") //权限提示
  },
  {
    path: "/notice",
    name: "notice",
    component: () => import("@/pages/notice/notice.vue") //通知
  },
  {
    path: "/customerService",
    name: "customerService",
    component: () => import("@/pages/customerService/customerService.vue") //客服
  },
  {
    path: "/messageRecord",
    name: "messageRecord",
    component: () => import("@/pages/customerService/messageRecord.vue") //客服
  },
  {
    path: "/pictures",
    name: "pictures",
    component: () => import("@/pages/picture/pictures.vue") //拍照
  },
  {
    path: "/picturesRecord",
    name: "picturesRecord",
    component: () => import("@/pages/picture/picturesrecord.vue") //拍照
  },
  {
    path: "/record",
    name: "record",
    component: () => import("@/pages/record/record.vue") //打卡记录
  },
  {
    path: "/privacy",
    name: "privacy",
    component: () => import("@/pages/privacy/privacy.vue") //打卡记录
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/pages/account/account.vue") //账户
  },
  {
    path: "/recherche",
    name: "recherche",
    component: () => import("@/pages/manager/child/recherche.vue") //账户
  },
  {
    path: "/assist",
    name: "assist",
    component: () => import("@/pages/assist/assist.vue") //账户
  },
  {
    path: "/lishilii",
    name: "lishilii",
    component: () => import("@/pages/manager/child/lishilii.vue") //员工
  },
  {
    path: "/employeeDetails",
    name: "employeeDetails",
    component: () =>
      import("@/pages/manager/employeeDetails/employeeDetails.vue") //员工
  },
  {
    path: "/manager",
    name: "manager",
    component: () => import("@/pages/manager/manager.vue"), //账户
    redirect: "/messagelist",
    children: [
      {
        path: "/messagelist",
        name: "messagelist",
        component: () => import("@/pages/manager/child/messagelist.vue") //账户
      },
      {
        path: "/allcontrol",
        name: "allcontrol",
        component: () => import("@/pages/manager/child/allcontrol.vue") //账户
      },
      {
        path: "/employees",
        name: "employees",
        component: () => import("@/pages/manager/child/employees.vue") //员工
      },
      {
        path: "/cooperation",
        name: "cooperation",
        component: () => import("@/pages/manager/child/cooperation.vue") //员工
      },
      {
        path: "/recorrd",
        name: "recorrd",
        component: () => import("@/pages/manager/child/recorrd.vue") //员工
      },
      {
        path: "/recorrddatil",
        name: "recorrddatil",
        component: () => import("@/pages/manager/child/recorrddatil.vue") //员工
      }
    ]
  }
];

const router = new Router({
  routes: routers
});

let token = "";

//全局路由守卫
router.beforeResolve((to, from, next) => {
  console.log("😍 ~ router.beforeResolve ~ to→", to);
  token = getToken();
  if (
    token ||
    ["/register", "/login", "/takePicture", "/idCard", "/privacy"].includes(
      to.path
    )
  ) {
    next();
  } else {
    next("/login");
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js